import React,{useState,useEffect} from 'react'
import Box from '@mui/material/Box';
import {Typography,Button,Grid,} from '@mui/material';
import {makeStyles} from '@mui/styles';
import Divider from '@mui/material/Divider'
import Project from './../components/Project'


const useStyles = makeStyles((theme)=>({
   
    companyName:{
        [theme.breakpoints.down("800")]:{
            margin:'0px'
           }
    }, aboutContainer:{
        width:'99%',
        height:'700px',
        display:'flex',
        justifyContent:'center',
       
        alignItems:'center',
        [theme.breakpoints.down("800")]:{
            alignItems:'normal',
            height:'100%'
        }
    },
    aboutHeader:{
        color:'#64ffda',
        fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",
        fontSize:'10vw',
        

    },aboutMe:{
        marginInline:'10px',color:'#ccd6f6',
        [theme.breakpoints.down("800")]:{
            fontSize:'8vw'
           
        }
    },divider:{
        width:'300px',
        backgroundColor:'#233554',
        alignSelf:'center',
        marginLeft:'20px',
        [theme.breakpoints.down("800")]:{
          width:'50px'
        }
    },container:{
        width:'85%', [theme.breakpoints.down("800")]:{
            width:'95%'
          }
    },headingContainer:{
        marginBottom:"25px"
    },
    firstRow:{
        [theme.breakpoints.down("800")]:{
            display:'flex',alignItems:'center',
            justifyContent:'center'
          }
    },
    projectElement:{
        
        [theme.breakpoints.down("800")]:{
            display:'flex',alignItems:'center',
            justifyContent:'center'
          },
        }
    
}))


const TopProjects = ({refer}) => {
    const classes = useStyles()
    useEffect(()=>{
       
    },[refer])
    return (
        <div ref={refer} style={{display:'flex',alignItems:'center',justifyContent:'center',marginTop:'50px'}}>

            <Box  className={classes.container}>
                <Box className={ classes.headingContainer} >
                    <Box style={{display:'flex',flexDirection:'row'}} className={classes.aboutMeContainer}>
                        <Typography className={classes.aboutHeader} style={{fontSize:'22px',alignSelf:'center',margin:"0px 5px 0px 5px",fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>02.</Typography>
                        <Typography className={classes.aboutMe} style={{fontSize:'26px',fontWeight:'600',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>Some Things I've Built</Typography>
                        <Divider orientation="horizontal"  className={classes.divider}/>
                    </Box>
                </Box>

                    <Grid container >
                        <Grid container spacing={1} className={classes.firstRow}>
                            <Grid item xs={12} lg={4} md={6} className={classes.projectElement}>
                                <Project 
                                    projectTitle={"GrociSco complete ecommerce app"} 
                                    projectDesc={"GrociSco mobile app built for ordering groceries.Includes a special feature to order products using images.Online payment also included."}
                                    projectTech={{"one":"React-Native","two":"Firebase","three":"Redux"}}
                                    gitHubLink={"https://github.com/Suprith461/GrociSco"}
                                    demoLink={"https://drive.google.com/file/d/1-67rEfDqNPEJ7-atcFoFWVmppvjfJhXU/view"}
                                    demoAvailable={true}
                                />
                            </Grid>
                            <Grid item xs={12} lg={4} md={6} className={classes.projectElement}>
                                <Project 
                                        projectTitle={"Custom URL shortner web app"} 
                                        projectDesc={"URL shortner web app allows users to shorten a long url into a custom short url.It was developed in 48 hours as a part of TallyCodeBrewers challenge."}
                                        projectTech={{"one":"React","two":"Material-UI","three":"express-js"}}
                                        gitHubLink={"https://github.com/Suprith461/urlShortner"}
                                        demoLink={"https://github.com/Suprith461/urlShortner"}
                                        demoAvailable={false}
                                    />
                            </Grid>
                            <Grid item xs={12} lg={4} md={6} className={classes.projectElement}>
                                <Project 
                                        projectTitle={"Bsoft web app for APMC"} 
                                        projectDesc={"Bsoft web app offers variety of services to shops in APMC.Some of the important features include invoice priniting, storing data of the purchased items, client creation, payment data storage etc."}
                                        projectTech={{"one":"React-Native","two":"Firebase","three":"Redux"}}
                                        gitHubLink={"https://github.com/Suprith461/BSoft"}
                                        demoLink={"https://drive.google.com/file/d/19cCwYl-e4LDSmIWCtDTY2YWUUNeSyr9Y/view"}
                                        demoAvailable={true}
                                    />
                            </Grid>
                        </Grid>
                        <Grid container style={{marginTop:'25px'}} spacing={1} className={classes.secondRow}>
                            <Grid item xs={12} lg={4} md={6} className={classes.projectElement}>
                                <Project 
                                        projectTitle={"Raag-Ads ppt generator"} 
                                        projectDesc={"Raag-Ads ppt generator is a desktop app developed particularly for outdoor-advertising agencies.It generates PPT's containing 100's of slides within minutes automatically on a button press."}
                                        projectTech={{"one":"Python","two":"Python-pptx","three":"Pandas"}}
                                        gitHubLink={"https://github.com/Suprith461/RaagAdsPPTgenerator"}
                                        demoLink={"https://drive.google.com/file/d/1Y9UGNUnFGXTBQ2MeBDUt9SgfX0l14HR3/view"}
                                        demoAvailable={true}
                                    />
                            </Grid>
                            <Grid item xs={12} lg={4} md={6} className={classes.projectElement}>
                                <Project 
                                        projectTitle={"Prabhu Associates"} 
                                        projectDesc={"It's a software particularly designed and developed for accontants filing IT returns of their clients.Offers various features like maintainance of payment history,invoice etc."}
                                        projectTech={{"one":"Python","two":"Pandas","three":"Tkinter"}}
                                        gitHubLink={"https://github.com/Suprith461?tab=repositories"}
                                        demoLink={"https://drive.google.com/file/d/1up5wjML23K08yeycCga_vHUYgpDJeHaR/view"}
                                        demoAvailable={true}
                                    />
                            </Grid>
                            <Grid item xs={12} lg={4} md={6} className={classes.projectElement}>
                                <Project 
                                        projectTitle={"Mask detetctor model"} 
                                        projectDesc={"It's an ANN model developed using data from github and trained on Renet-50 model. It's a model with 95% accuracy when run in a good lighting conditions. "}
                                        projectTech={{"one":"Deep-Learning","two":"Tensorflow","three":"Resnet-50"}}
                                        gitHubLink={"https://www.linkedin.com/posts/suprith-hattikal-983b011a1_python-deeplearning-machinelearning-activity-6678179847388430336-Zf-y"}
                                        demoLink={"https://www.linkedin.com/posts/suprith-hattikal-983b011a1_python-deeplearning-machinelearning-activity-6678179847388430336-Zf-y"}
                                        demoAvailable={true}
                                    />
                            </Grid>
                        </Grid>
                        
                    </Grid>
                    
                    
                
            </Box>
           
            
        </div>
    )
}

export default TopProjects
